var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3578.6963,
    y1: 4044.655,
    x2: 1120.8385,
    y2: 992.15
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2903.838,2839.948c-56.528,59.385-110.014,97.682-152.273,127.939 c-496.74,355.666-1084.516,251.991-1209.435,226.672c-184.466-37.387-541.035-109.656-798.828-412.176 C353.283,2324.695,414.015,1603.62,716.54,1127.629c55.337-87.067,347.641-570.309,941.747-647.805 c359.547-46.9,778.663,47.692,1082.175,301.439C3377.563,1313.901,3332.208,2389.925,2903.838,2839.948z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1455.568,721.358c-4.308,3.926-10.984,3.613-14.907-0.695 c-7.625-8.369-15.725-16.533-24.079-24.263c-4.227-3.911-4.528-10.477-0.715-14.758c0.045-0.051,0.09-0.101,0.137-0.154 c3.958-4.277,10.634-4.534,14.912-0.575c8.792,8.137,17.321,16.73,25.347,25.541c3.671,4.028,3.634,10.13,0.087,14.112 C1456.105,720.841,1455.846,721.107,1455.568,721.358z M1373.341,661.565c-9.325-6.516-19.016-12.695-28.814-18.369 c-5.039-2.918-6.763-9.374-3.844-14.417c2.948-5.051,9.378-6.762,14.421-3.841c10.308,5.969,20.511,12.472,30.324,19.327 c4.776,3.338,5.942,9.918,2.604,14.694c-0.243,0.347-0.503,0.675-0.777,0.983 C1383.748,663.879,1377.771,664.66,1373.341,661.565z M1294.682,618.793c-10.512-4.265-21.337-8.125-32.181-11.472 c-5.567-1.718-8.688-7.627-6.97-13.195c1.723-5.56,7.625-8.685,13.195-6.969c11.42,3.525,22.822,7.591,33.89,12.082 c5.4,2.191,7.999,8.345,5.812,13.745c-0.468,1.151-1.115,2.175-1.896,3.052C1303.647,619.274,1298.93,620.517,1294.682,618.793 z M1208.432,594.688c-11.214-1.811-22.635-3.153-33.95-3.996c-5.811-0.434-10.172-5.497-9.739-11.306 c0.439-5.81,5.5-10.166,11.306-9.739c11.914,0.889,23.938,2.304,35.74,4.204c5.752,0.928,9.665,6.345,8.736,12.097 c-0.332,2.058-1.238,3.881-2.529,5.331C1215.679,593.882,1212.126,595.281,1208.432,594.688z M1118.962,590.398 c-11.308,0.724-22.747,1.942-33.993,3.626c-5.765,0.859-11.135-3.114-11.997-8.877c-0.863-5.767,3.113-11.136,8.877-11.993 c11.832-1.771,23.868-3.052,35.766-3.814c5.814-0.374,10.831,4.039,11.202,9.855c0.188,2.93-0.839,5.658-2.65,7.691 C1124.386,588.888,1121.847,590.214,1118.962,590.398z M1030.772,606.013c-10.884,3.211-21.764,6.93-32.341,11.054 c-5.429,2.117-11.548-0.569-13.663-5.995c-2.118-5.43,0.564-11.547,5.995-13.666c11.129-4.341,22.584-8.254,34.038-11.634 c5.59-1.647,11.455,1.546,13.106,7.136c1.071,3.631,0.097,7.377-2.248,10.01 C1034.395,604.338,1032.733,605.435,1030.772,606.013z M748.737,877.998c-5.565-1.727-8.677-7.64-6.948-13.206 c3.541-11.4,7.63-22.801,12.15-33.882c2.202-5.397,8.36-7.986,13.755-5.783c5.394,2.198,7.983,8.357,5.783,13.752 c-4.292,10.521-8.172,21.347-11.533,32.173c-0.461,1.485-1.219,2.794-2.191,3.885 C757.086,877.933,752.817,879.267,748.737,877.998z M948.289,640.765c-9.892,5.548-19.664,11.593-29.042,17.971 c-4.821,3.275-11.385,2.025-14.66-2.794c-3.278-4.821-2.007-11.361,2.795-14.659c9.877-6.715,20.167-13.082,30.585-18.923 c5.082-2.85,11.513-1.041,14.364,4.043c2.261,4.031,1.59,8.911-1.321,12.18C950.252,639.435,949.339,640.175,948.289,640.765z  M783.556,792.885c-5.036-2.929-6.744-9.389-3.814-14.427c6.004-10.316,12.533-20.51,19.398-30.301 c3.328-4.79,9.927-5.922,14.698-2.579c4.769,3.346,5.924,9.926,2.578,14.698c-6.526,9.304-12.731,18.992-18.434,28.797 c-0.364,0.625-0.785,1.197-1.248,1.717C793.467,794.46,787.965,795.451,783.556,792.885z M875.653,693.071 c-8.396,7.617-16.574,15.696-24.306,24.019c-3.965,4.272-10.64,4.517-14.912,0.55c-4.213-3.915-4.507-10.469-0.7-14.744 c0.049-0.056,0.1-0.113,0.153-0.165c8.137-8.764,16.746-17.272,25.581-25.289c4.319-3.913,10.991-3.59,14.907,0.726 c3.658,4.03,3.614,10.121,0.073,14.097C876.201,692.543,875.933,692.812,875.653,693.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M744.271,947.393c1.382-1.551,2.323-3.525,2.59-5.746c0.649-5.402,1.426-10.878,2.298-16.282 c0.933-5.751-2.976-11.172-8.727-12.102c-5.752-0.934-11.179,2.972-12.102,8.73c-0.922,5.683-1.736,11.443-2.422,17.127 c-0.697,5.784,3.428,11.042,9.211,11.738C738.688,951.289,742.051,949.886,744.271,947.393z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M833.547,1256.442c3.387-3.803,3.61-9.606,0.289-13.679c-3.439-4.214-6.848-8.572-10.129-12.951 c-3.496-4.664-10.109-5.611-14.771-2.117c-4.682,3.51-5.61,10.11-2.117,14.772c3.456,4.609,7.045,9.199,10.665,13.638 c3.684,4.515,10.331,5.188,14.846,1.506C832.773,1257.248,833.179,1256.855,833.547,1256.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1444.578,1285.703c-4.083,4.157-10.765,4.216-14.923,0.129 c-4.155-4.084-4.21-10.753-0.129-14.92c7.776-7.913,15.334-16.281,22.558-24.962c3.694-4.47,10.382-5.087,14.861-1.36 s5.089,10.38,1.363,14.86c-3.13,3.761-6.309,7.456-9.538,11.081C1454.162,1275.703,1449.388,1280.809,1444.578,1285.703z  M1487.464,1216.213c-4.94-3.086-6.445-9.595-3.357-14.536c5.924-9.49,11.515-19.33,16.61-29.253 c2.643-5.186,9.021-7.229,14.206-4.567c5.181,2.66,7.226,9.021,4.564,14.204c-5.364,10.447-11.247,20.808-17.484,30.792 c-0.323,0.518-0.685,0.999-1.077,1.439C1497.569,1218.061,1491.89,1218.977,1487.464,1216.213z M1401.566,1323.859 c-9.295,7.17-19.024,14.042-28.921,20.419c-4.898,3.157-11.428,1.745-14.587-3.154c-3.156-4.897-1.74-11.421,3.154-14.585 c9.4-6.055,18.637-12.578,27.462-19.389c4.615-3.558,11.24-2.705,14.802,1.91c3.148,4.082,2.84,9.738-0.468,13.453 C1402.577,1322.996,1402.097,1323.449,1401.566,1323.859z M1528.742,1135.683c-5.499-1.925-8.399-7.946-6.47-13.445 c3.693-10.542,6.977-21.369,9.765-32.176c1.454-5.648,7.206-9.039,12.851-7.582c5.642,1.454,9.036,7.206,7.582,12.848 c-2.935,11.383-6.395,22.784-10.282,33.885c-0.471,1.341-1.182,2.529-2.073,3.53 C1537.356,1135.84,1532.898,1137.139,1528.742,1135.683z M1322.326,1372.01c-10.638,4.947-21.636,9.507-32.693,13.555 c-5.471,2.004-11.529-0.805-13.534-6.276c-2.007-5.474,0.806-11.534,6.278-13.538c10.501-3.847,20.949-8.177,31.05-12.876 c5.285-2.457,11.561-0.165,14.018,5.12c1.831,3.937,1.025,8.424-1.689,11.471 C1324.827,1370.509,1323.672,1371.384,1322.326,1372.01z M1234.447,1401.616c-11.49,2.508-23.219,4.56-34.862,6.101 c-5.779,0.762-11.08-3.3-11.845-9.078c-0.764-5.786,3.3-11.086,9.078-11.842c11.062-1.464,22.209-3.415,33.128-5.796 c5.694-1.243,11.316,2.365,12.559,8.059c0.747,3.431-0.266,6.836-2.436,9.272 C1238.64,1399.938,1236.708,1401.123,1234.447,1401.616z M1142.201,1411.368c-11.769-0.053-23.668-0.605-35.36-1.637 c-5.807-0.514-10.094-5.634-9.583-11.438c0.513-5.813,5.635-10.095,11.438-9.583c11.112,0.983,22.415,1.504,33.601,1.555 c5.827,0.026,10.53,4.773,10.502,10.598c-0.011,2.678-1.018,5.115-2.668,6.968 C1148.188,1410.013,1145.352,1411.381,1142.201,1411.368z M1050.026,1400.764c-11.471-2.625-22.964-5.771-34.158-9.352 c-5.55-1.775-8.612-7.714-6.835-13.265c1.772-5.541,7.715-8.607,13.265-6.832c10.627,3.399,21.539,6.386,32.437,8.88 c5.68,1.3,9.23,6.957,7.93,12.637c-0.411,1.794-1.255,3.374-2.399,4.658C1057.79,1400.27,1053.915,1401.653,1050.026,1400.764z  M962.388,1370.15c-10.585-5.076-21.093-10.673-31.235-16.637c-5.024-2.954-6.703-9.422-3.748-14.445 c2.946-5.006,9.418-6.702,14.442-3.747c9.634,5.666,19.615,10.981,29.669,15.805c5.253,2.518,7.47,8.822,4.949,14.075 c-0.439,0.915-0.991,1.739-1.634,2.461C971.784,1371.083,966.727,1372.231,962.388,1370.15z M883.693,1321.09 c-6.799-5.349-13.517-10.974-19.965-16.717c-2.336-2.081-4.639-4.179-6.918-6.299c-4.264-3.968-4.638-10.668-0.536-14.91 c3.967-4.268,10.644-4.509,14.912-0.539c2.164,2.013,4.357,4.013,6.576,5.989c6.131,5.461,12.514,10.806,18.978,15.892 c4.58,3.602,5.371,10.236,1.768,14.815c-0.136,0.171-0.275,0.34-0.419,0.502 C894.409,1323.956,888.099,1324.559,883.693,1321.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1560.406,1044.313c1.395-1.567,2.338-3.561,2.599-5.799c0.656-5.675,1.203-11.47,1.628-17.227 c0.43-5.813-3.933-10.872-9.744-11.3c-5.812-0.427-10.872,3.928-11.3,9.744c-0.404,5.468-0.925,10.973-1.546,16.361 c-0.671,5.785,3.479,11.022,9.269,11.691C1554.859,1048.193,1558.199,1046.791,1560.406,1044.313z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1448.165,902.461c-0.334-2.078-1.947-3.715-4.02-4.078l-59.121-10.351 c-10.626-25.938-25.464-50.367-44.355-72.166l17.416-57.398c0.611-2.014-0.124-4.192-1.828-5.426l-58.314-42.219 c-1.704-1.235-4.004-1.251-5.725-0.043l-49.093,34.464c-26.607-11.141-54.448-17.613-82.407-19.61l-28.289-52.935 c-0.992-1.855-3.052-2.877-5.129-2.545l-71.089,11.38c-2.077,0.332-3.716,1.947-4.078,4.019l-10.35,59.121 c-25.938,10.625-50.368,25.463-72.167,44.355l-57.398-17.416c-2.014-0.611-4.193,0.122-5.426,1.827l-42.221,58.315 c-1.233,1.705-1.25,4.004-0.041,5.725l34.465,49.093c-11.142,26.607-17.613,54.448-19.609,82.407l-52.936,28.289 c-1.855,0.992-2.878,3.051-2.545,5.129l11.38,71.089c0.332,2.077,1.947,3.714,4.018,4.078l59.123,10.351 c10.625,25.938,25.463,50.367,44.355,72.166l-17.416,57.398c-0.612,2.013,0.122,4.193,1.826,5.426l58.316,42.221 c1.704,1.234,4.003,1.25,5.725,0.042l49.093-34.464c26.607,11.141,54.449,17.612,82.407,19.61l28.289,52.935 c0.991,1.856,3.05,2.878,5.129,2.545l71.089-11.381c2.077-0.333,3.715-1.947,4.078-4.019l10.35-59.122 c25.938-10.625,50.367-25.464,72.167-44.354l57.398,17.416c2.012,0.61,4.191-0.123,5.426-1.827l42.22-58.315 c1.234-1.704,1.251-4.003,0.042-5.725l-34.464-49.092c11.142-26.607,17.611-54.448,19.609-82.407L1457,978.679 c1.856-0.991,2.877-3.052,2.545-5.129L1448.165,902.461z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1188.171,1043.47c-30.601,25.609-76.329,21.552-101.942-9.05 c-12.408-14.823-18.299-33.591-16.588-52.845c1.708-19.251,10.81-36.69,25.638-49.095 c30.601-25.609,76.329-21.552,101.942,9.05c23.299,27.84,22.042,68.2-1.419,94.543 C1193.476,1038.684,1190.929,1041.16,1188.171,1043.47z M1086.457,983.068c-1.31,14.764,3.206,29.151,12.719,40.519 c19.635,23.459,54.7,26.574,78.16,6.937c23.475-19.634,26.574-54.7,6.938-78.162c-19.635-23.459-54.7-26.574-78.16-6.938 c-2.127,1.781-4.097,3.695-5.908,5.729C1092.337,959.989,1087.523,971.07,1086.457,983.068z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1272.871,1106.694c4.029-4.524,7.855-9.278,11.457-14.252l0,0 c1.134-1.565,2.242-3.15,3.326-4.751c5.339-7.898,10.042-16.208,14.036-24.801c0.054-0.117,0.109-0.234,0.164-0.351 c0.153-0.333,0.306-0.666,0.456-1.001c0.297-0.649,0.586-1.302,0.874-1.954c0.756-1.716,0.277-3.664-1.051-4.849 c-0.323-0.288-0.698-0.53-1.114-0.714c-2.133-0.939-4.619,0.037-5.56,2.165c-4.828,10.98-10.873,21.511-17.967,31.303 c-35.215,48.656-91.651,73.055-147.578,69.742c-31.108-1.839-62.059-12.257-89.116-31.849 c-4.746-3.434-9.283-7.084-13.597-10.928c-29.039-25.869-48.14-60.649-54.369-99.568 c-7.158-44.706,3.523-89.524,30.073-126.195c54.841-75.731,160.994-92.701,236.694-37.893 c4.668,3.379,9.147,6.982,13.421,10.791c18.523,16.503,33.229,36.875,42.991,59.706c0.253,0.59,0.622,1.092,1.073,1.491 c1.182,1.053,2.914,1.395,4.466,0.729c2.142-0.924,3.143-3.393,2.221-5.542c-10.249-23.97-25.688-45.36-45.134-62.685 c-4.486-3.998-9.187-7.779-14.085-11.328c-79.478-57.544-190.96-39.671-248.484,39.777 c-27.874,38.499-39.084,85.547-31.57,132.48c6.538,40.859,26.591,77.37,57.076,104.529c4.531,4.035,9.293,7.865,14.271,11.472 c38.502,27.874,85.551,39.087,132.482,31.574C1209.194,1157.253,1245.712,1137.189,1272.871,1106.694z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1903.467,636.614c1.875-2.105,2.229-5.268,0.659-7.782c-2.927-4.694-6.037-9.365-9.243-13.878 c-2.083-2.933-6.148-3.622-9.087-1.539c-2.947,2.075-3.622,6.153-1.539,9.087c3.055,4.302,6.02,8.752,8.814,13.232 c1.901,3.052,5.921,3.982,8.978,2.081C1902.59,637.474,1903.062,637.068,1903.467,636.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1872.676,597.171c-2.656,2.428-6.775,2.249-9.208-0.407 c-6.137-6.697-12.688-13.158-19.47-19.198c-1.43-1.274-2.881-2.535-4.349-3.787c-2.733-2.337-3.059-6.449-0.723-9.188 c2.312-2.5,6.449-3.059,9.192-0.723c1.534,1.311,3.051,2.632,4.548,3.965c7.109,6.332,13.979,13.106,20.412,20.132 c2.278,2.484,2.262,6.263,0.066,8.729C1872.999,596.857,1872.841,597.015,1872.676,597.171z M1813.217,553.862 c-9.184-6.079-18.826-11.645-28.658-16.537c-3.223-1.605-4.534-5.512-2.931-8.737c1.6-3.203,5.514-4.536,8.738-2.931 c10.305,5.127,20.416,10.96,30.044,17.336c3.002,1.988,3.824,6.031,1.839,9.035c-0.174,0.262-0.37,0.51-0.575,0.74 C1819.553,555.15,1815.953,555.672,1813.217,553.862z M1754.064,524.458c-10.377-3.639-21.091-6.661-31.853-8.989 c-3.515-0.761-5.751-4.231-4.99-7.746c0.765-3.528,4.224-5.757,7.746-4.994c11.284,2.439,22.525,5.616,33.406,9.426 c3.396,1.192,5.188,4.911,3.997,8.306c-0.293,0.826-0.733,1.56-1.283,2.177 C1759.384,524.551,1756.632,525.355,1754.064,524.458z M1689.493,510.485c-10.97-0.984-22.103-1.295-33.074-0.92 c-3.601,0.12-6.615-2.696-6.735-6.293c-0.12-3.588,2.692-6.61,6.288-6.735c11.512-0.391,23.179-0.065,34.685,0.966 c3.584,0.32,6.231,3.491,5.911,7.076c-0.135,1.444-0.725,2.737-1.622,3.745C1693.62,509.814,1691.632,510.677,1689.493,510.485 z M1623.468,512.701c-10.875,1.713-21.741,4.115-32.308,7.138c-3.456,0.991-7.065-1.013-8.057-4.474 c-0.991-3.461,1.006-7.072,4.474-8.057c11.072-3.169,22.466-5.686,33.861-7.485c3.556-0.557,6.892,1.869,7.452,5.422 c0.317,2.008-0.32,3.947-1.573,5.354C1626.35,511.684,1625.016,512.455,1623.468,512.701z M1559.981,530.876 c-10.121,4.302-20.065,9.277-29.561,14.791c-3.109,1.807-7.101,0.749-8.906-2.363c-1.805-3.112-0.752-7.088,2.363-8.911 c9.956-5.782,20.392-11.002,31.008-15.515c3.313-1.404,7.139,0.137,8.545,3.447c1.017,2.398,0.491,5.066-1.132,6.888 C1561.677,529.911,1560.899,530.488,1559.981,530.876z M1502.892,564.013c-8.728,6.633-17.156,13.904-25.047,21.616 c-2.577,2.512-6.702,2.464-9.215-0.112c-2.515-2.572-2.432-6.656,0.106-9.219c8.278-8.078,17.113-15.703,26.267-22.66 c2.867-2.177,6.956-1.62,9.134,1.245c1.915,2.519,1.712,5.991-0.319,8.271C1503.543,563.463,1503.235,563.752,1502.892,564.013 z M1427.629,639.371c-3.066-1.887-4.02-5.898-2.132-8.964c5.222-8.485,11.001-16.83,17.153-24.781 c0.929-1.214,1.871-2.407,2.821-3.598c2.156-2.86,6.351-3.266,9.162-1.005c2.81,2.251,3.259,6.349,1.01,9.162 c-0.896,1.112-1.779,2.238-2.665,3.395c-5.891,7.609-11.403,15.569-16.385,23.659c-0.204,0.334-0.436,0.643-0.686,0.923 C1433.844,640.479,1430.359,641.052,1427.629,639.371z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1872.832,967.96c-7.663,8.383-15.907,16.367-24.496,23.743c-2.731,2.34-6.845,2.03-9.191-0.703 c-2.347-2.733-1.99-6.838,0.703-9.191c8.193-7.029,16.054-14.648,23.365-22.646c2.427-2.658,6.552-2.84,9.205-0.413 c2.634,2.41,2.839,6.487,0.473,9.143C1872.872,967.915,1872.851,967.939,1872.832,967.96z M1885.215,942.937 c-2.927-2.092-3.604-6.163-1.51-9.088c6.295-8.809,12.12-18.086,17.312-27.58c1.725-3.134,5.687-4.318,8.848-2.585 c3.158,1.726,4.314,5.682,2.59,8.843c-5.442,9.948-11.546,19.672-18.146,28.9c-0.14,0.195-0.284,0.377-0.441,0.553 C1891.683,944.431,1887.954,944.894,1885.215,942.937z M1821.114,1012.307c-9.467,6.286-19.398,12.048-29.517,17.124 c-3.218,1.613-7.137,0.311-8.748-2.904c-1.617-3.217-0.317-7.117,2.899-8.748c9.655-4.84,19.125-10.335,28.161-16.328 c3-1.99,7.043-1.172,9.031,1.821c1.674,2.522,1.362,5.781-0.559,7.939C1822.017,1011.62,1821.594,1011.989,1821.114,1012.307z  M1918.508,885.269c-3.345-1.326-4.98-5.117-3.654-8.461c3.993-10.062,7.405-20.467,10.14-30.934 c0.915-3.476,4.476-5.562,7.95-4.659c3.483,0.912,5.571,4.472,4.659,7.954c-2.865,10.977-6.444,21.895-10.634,32.446 c-0.292,0.729-0.698,1.377-1.191,1.93C1924.009,885.532,1921.122,886.306,1918.508,885.269z M1760.234,1042.83 c-10.677,3.816-21.7,7.016-32.765,9.518c-3.511,0.794-7.001-1.412-7.794-4.922c-0.794-3.511,1.404-7.003,4.922-7.795 c10.557-2.38,21.067-5.435,31.249-9.079c3.388-1.21,7.118,0.553,8.33,3.947c0.831,2.321,0.26,4.808-1.274,6.531 C1762.201,1041.817,1761.298,1042.449,1760.234,1042.83z M1693.798,1057.859c-11.302,1.15-22.776,1.622-34.098,1.407 c-3.596-0.068-6.457-3.037-6.388-6.635c0.065-3.594,3.036-6.461,6.64-6.393c10.796,0.203,21.742-0.251,32.528-1.347 c3.58-0.365,6.778,2.244,7.143,5.825c0.191,1.891-0.445,3.677-1.62,4.996 C1696.958,1056.886,1695.484,1057.687,1693.798,1057.859z M1625.67,1056.549c-11.257-1.589-22.514-3.886-33.453-6.818 c-3.479-0.935-5.539-4.507-4.606-7.984c0.93-3.476,4.51-5.533,7.98-4.607c10.433,2.802,21.166,4.989,31.898,6.498 c3.565,0.504,6.048,3.802,5.542,7.365c-0.183,1.324-0.755,2.493-1.581,3.42 C1630.049,1055.996,1627.913,1056.863,1625.67,1056.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1942.666,818.836c0.836-0.939,1.409-2.128,1.589-3.468c0.74-5.529,1.316-11.104,1.721-16.573 c0.263-3.588-2.431-6.716-6.02-6.982c-3.583-0.254-6.709,2.432-6.981,6.021c-0.383,5.215-0.936,10.534-1.639,15.811 c-0.477,3.568,2.032,6.846,5.598,7.321C1939.16,821.261,1941.276,820.397,1942.666,818.836z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1868.58,719.32c-0.224-1.39-1.303-2.486-2.69-2.729l-39.562-6.927 c-7.11-17.356-17.04-33.703-29.68-48.29l11.654-38.408c0.409-1.347-0.082-2.805-1.223-3.631l-39.021-28.251 c-1.14-0.827-2.679-0.837-3.83-0.029l-32.851,23.063c-17.804-7.456-36.434-11.786-55.143-13.122l-18.93-35.421 c-0.664-1.242-2.042-1.925-3.432-1.703l-47.569,7.615c-1.39,0.222-2.486,1.302-2.729,2.69l-6.926,39.561 c-17.357,7.11-33.704,17.039-48.291,29.681l-38.408-11.654c-1.347-0.409-2.805,0.082-3.631,1.222l-28.252,39.022 c-0.826,1.141-0.836,2.679-0.028,3.831l23.062,32.851c-7.456,17.804-11.786,36.434-13.122,55.143l-35.423,18.93 c-1.241,0.664-1.926,2.042-1.703,3.431l7.615,47.57c0.223,1.389,1.303,2.485,2.689,2.728l39.563,6.927 c7.109,17.356,17.038,33.703,29.68,48.291l-11.654,38.408c-0.41,1.347,0.082,2.805,1.222,3.631L1558.99,962 c1.14,0.825,2.678,0.836,3.831,0.028l32.85-23.062c17.804,7.456,36.435,11.786,55.143,13.122l18.93,35.422 c0.663,1.242,2.041,1.925,3.432,1.703l47.569-7.615c1.39-0.223,2.486-1.303,2.729-2.689l6.926-39.561 c17.357-7.11,33.703-17.039,48.291-29.68l38.408,11.655c1.347,0.408,2.805-0.082,3.631-1.223l28.251-39.022 c0.825-1.14,0.837-2.679,0.028-3.831l-23.061-32.85c7.456-17.804,11.785-36.435,13.122-55.143l35.422-18.93 c1.242-0.663,1.925-2.042,1.703-3.432L1868.58,719.32z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1695.164,814.34c-10.097,8.456-22.883,12.469-36,11.303 c-13.112-1.161-24.99-7.364-33.441-17.464c-17.444-20.841-14.677-51.937,6.164-69.443c20.85-17.44,51.998-14.674,69.435,6.166 c8.452,10.097,12.467,22.881,11.303,35.995c-0.947,10.661-5.224,20.505-12.216,28.356 C1698.803,811.057,1697.049,812.759,1695.164,814.34z M1635.715,799.812c6.218,7.43,14.954,11.993,24.605,12.85 c9.644,0.855,19.05-2.098,26.477-8.313l0,0c7.42-6.226,11.988-14.954,12.845-24.604c0.859-9.644-2.099-19.049-8.311-26.474 c-12.832-15.332-35.743-17.367-51.079-4.539c-1.382,1.16-2.656,2.398-3.822,3.708 C1624.673,765.638,1624.043,785.867,1635.715,799.812z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1754.118,858.34c2.743-3.079,5.349-6.323,7.821-9.729c4.903-6.768,9.122-14.041,12.548-21.639 c0.151-0.342,0.303-0.685,0.454-1.027c1.168-2.651,0.428-5.657-1.623-7.488c-0.499-0.444-1.077-0.819-1.72-1.102 c-3.294-1.45-7.128,0.061-8.585,3.343c-3.131,7.123-7.046,13.939-11.629,20.263l-0.002,0.002 c-0.25,0.348-0.508,0.694-0.761,1.035c-10.984,14.868-25.257,26.435-41.578,34.044c-8.86,4.13-18.33,7.089-28.216,8.763 c-0.08,0.014-0.16,0.027-0.241,0.041c-0.248,0.039-0.491,0.082-0.737,0.119c-28.941,4.631-57.955-2.282-81.695-19.471 c-3.074-2.222-6.008-4.584-8.802-7.073c-18.799-16.747-31.163-39.264-35.199-64.462c-4.631-28.942,2.286-57.952,19.473-81.689 c17.186-23.717,42.594-39.366,71.533-44.004c28.941-4.631,57.955,2.282,81.695,19.471c3.022,2.185,5.921,4.519,8.687,6.982 c11.993,10.686,21.512,23.872,27.831,38.652c0.391,0.911,0.96,1.687,1.656,2.302c1.825,1.625,4.5,2.154,6.897,1.127 c3.305-1.424,4.847-5.242,3.429-8.558c-7.071-16.537-17.722-31.294-31.134-43.247c-3.099-2.76-6.339-5.369-9.718-7.815 c-26.565-19.232-59.023-26.966-91.405-21.782c-32.376,5.186-60.805,22.639-80.027,49.226 c-19.232,26.56-26.969,59.016-21.781,91.399c4.509,28.189,18.344,53.379,39.377,72.115c3.122,2.781,6.408,5.426,9.843,7.914 C1641.933,913.283,1712.769,904.767,1754.118,858.34z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008137762857394043440000010576512712219546539_",
    gradientUnits: "userSpaceOnUse",
    x1: 1820.1746,
    y1: 3034.5579,
    x2: 1886.6429,
    y2: 428.9832
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008137762857394043440000010576512712219546539_)"
    },
    d: "M609.373,2641.508 c0,24.604,20.15,44.734,44.777,44.734h2421.353c24.627,0,44.777-20.13,44.777-44.734l20.148-1391.485 c0-24.603-28.987-72.636-82.111-69.027l-2366.413-61.231c-30.9-0.8-60.777,11.094-82.658,32.904 c-21.881,21.81-33.855,51.631-33.124,82.502L609.373,2641.508z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023980670172255876790000006779039814561240488_",
    gradientUnits: "userSpaceOnUse",
    x1: 619.825,
    y1: 1906.8712,
    x2: 3078.4849,
    y2: 1906.8712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023980670172255876790000006779039814561240488_)"
    },
    d: "M653.58,2598.591 c0,23.298,19.063,42.362,42.362,42.362H3017.11c23.299,0,42.362-19.063,42.362-42.362l19.013-1263.202 c-2.239-76.017-68.885-103.337-109.284-101.724L701.21,1172.818c-21.708-0.582-42.698,7.781-58.073,23.118 c-15.375,15.336-23.832,36.324-23.287,58.034L653.58,2598.591z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M3034.39,1824.886c-0.031,0-0.062,0-0.062,0c-3.461-0.038-6.2-2.214-6.147-4.863 l1.503-79.049c0.05-2.62,2.819-4.719,6.203-4.719c0.031,0,0.062,0,0.093,0c3.43,0.038,6.169,2.214,6.116,4.863l-1.503,79.049 C3040.543,1822.787,3037.773,1824.886,3034.39,1824.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M3038.077,1631.175c-0.031,0-0.062,0-0.093,0c-3.43-0.038-6.169-2.219-6.116-4.863 l5.76-302.76c-0.108-17.984-7.182-32.343-21.028-42.58c-25.846-19.107-66.881-18.132-68.61-18.07l-724.9-15 c-3.427-0.067-6.132-2.271-6.039-4.915c0.09-2.644,2.723-4.896,6.373-4.657l724.469,15c4.508-0.206,48.198-0.789,77.294,20.724 c16.369,12.102,24.731,28.776,24.855,49.547l-5.763,302.856C3044.23,1629.076,3041.46,1631.175,3038.077,1631.175z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024686236513552344780000001050788924374932902_",
    gradientUnits: "userSpaceOnUse",
    x1: 2271.9326,
    y1: 1206.8397,
    x2: 1876.9318,
    y2: 2699.8108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024686236513552344780000001050788924374932902_)"
    },
    d: "M505.722,2801.752h2720.825 c3.11,0,5.654-2.544,5.654-5.654v-110.953c0-3.11-2.544-5.654-5.654-5.654H505.722c-3.109,0-5.654,2.544-5.654,5.654v110.953 C500.068,2799.208,502.612,2801.752,505.722,2801.752z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7D97F4"
    },
    d: "M1690.405,2573.151H751.22c-9.743,0-17.641-7.898-17.641-17.641v-397.375 c0-9.743,7.898-17.641,17.641-17.641h939.185c9.743,0,17.641,7.898,17.641,17.641v397.375 C1708.046,2565.252,1700.148,2573.151,1690.405,2573.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7D97F4"
    },
    d: "M2957.068,1447.994H752.106c-24.078,0-43.597-19.519-43.597-43.597v-98.439 c0-33.107,27.118-59.797,60.221-59.27l2188.338,34.817c24.078,0,43.597,19.519,43.597,43.597v79.295 C3000.665,1428.475,2981.146,1447.994,2957.068,1447.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7D97F4"
    },
    d: "M1673.134,2102.44H733.949c-9.743,0-17.641-7.898-17.641-17.641v-561.613 c0-9.743,7.898-17.641,17.641-17.641h939.185c9.743,0,17.641,7.898,17.641,17.641v561.613 C1690.776,2094.542,1682.877,2102.44,1673.134,2102.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#7D97F4"
    },
    d: "M2959.667,2573.151H1761.173c-10.031,0-18.163-8.132-18.163-18.163V1530.695 c0-10.031,8.132-18.163,18.163-18.163h1198.494c10.031,0,18.163,8.132,18.163,18.163v1024.292 C2977.83,2565.019,2969.698,2573.151,2959.667,2573.151z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1266.087,2166.013c-37.504-122.964-111.605-221.562-200.026-280.133 c-79.043-52.359-135.515-132.998-155.73-225.534c-2.125-9.727-4.671-19.488-7.648-29.25 c-45.104-147.886-172.281-240.135-284.057-206.044c-111.776,34.091-165.824,181.613-120.719,329.499 c9.223,30.24,21.88,58.146,37.135,83.119c48.686,79.698,67.033,174.744,47.783,266.17 c-17.203,81.705-13.801,174.01,14.317,266.199c41.935,137.495,129.63,244.531,231.935,299.205 c38.697,20.68,73.491,48.255,102.191,81.395c47.694,55.071,115.472,81.573,178.226,62.433 c67.697-20.647,110.599-88.631,114.516-168.577c2.217-45.24,13.312-89.461,31.061-131.169 C1296.969,2414.864,1304.005,2290.337,1266.087,2166.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M705.748,1570.437c44.412,93.284,85.791,187.92,126.18,282.987 c10.108,23.762,19.832,47.685,29.634,71.574l14.696,35.838l14.397,35.961c9.505,24.011,19.343,47.891,28.576,72.011 l27.705,72.354c17.853,48.471,36.118,96.789,53.069,145.591c8.51,24.387,17.494,48.605,25.509,73.167l24.379,73.557 c31.513,98.399,60.567,197.637,84.544,298.15l-4.322,1.076l-20.802-74.521l-5.159-18.634l-5.624-18.506l-11.317-36.988 l-11.245-37.001c-3.726-12.34-7.91-24.542-11.843-36.82c-8.029-24.504-15.863-49.068-24.051-73.517 c-33.385-97.592-68.066-194.741-104.745-291.162c-18.709-48.07-37.004-96.296-56.048-144.24l-14.184-35.995l-14.485-35.876 c-9.643-23.924-19.286-47.848-29.171-71.674c-19.362-47.82-39.068-95.506-59.163-143.028 c-19.844-47.628-40.143-95.08-60.58-142.448L705.748,1570.437z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M598.478,1861.075c-1.078-0.104-2.103-0.671-2.755-1.639 c-78.044-115.892-75.404-208.549-59.448-265.872c17.336-62.273,52.735-96.512,54.234-97.94c1.499-1.431,3.869-1.37,5.301,0.129 c1.429,1.499,1.373,3.872-0.125,5.302c-0.354,0.338-35.58,34.494-52.287,94.907c-15.415,55.731-17.769,145.953,58.548,259.281 c1.158,1.719,0.703,4.051-1.015,5.207C600.18,1860.957,599.313,1861.155,598.478,1861.075z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M925.13,2509.256c-29.481-59.49-75.507-103.5-125.424-125.923 c-44.622-20.045-80.163-56.386-98.278-101.825c-1.904-4.776-4.025-9.534-6.366-14.258 c-35.456-71.547-107.93-107.875-161.873-81.142c-53.944,26.733-68.931,106.404-33.474,177.951 c7.25,14.63,16.048,27.783,25.919,39.225c31.503,36.514,48.88,83.389,46.836,131.571c-1.828,43.059,7.719,89.79,29.822,134.391 c32.965,66.52,86.617,113.688,143.262,132.962c21.426,7.29,41.452,18.419,58.851,32.894 c28.913,24.053,65.618,31.871,95.904,16.863c32.671-16.191,48.726-54.415,43.948-95.465 c-2.704-23.229-0.807-46.683,4.684-69.415C961.905,2633.421,954.938,2569.403,925.13,2509.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M589.797,2252.859c30.48,43.793,59.533,88.528,88.119,133.566 c7.152,11.256,14.122,22.626,21.128,33.973l10.507,17.023l10.366,17.11c6.866,11.434,13.89,22.773,20.627,34.284l20.214,34.532 c13.182,23.193,26.561,46.273,39.312,69.711c6.392,11.708,13.011,23.291,19.165,35.13l18.625,35.423 c24.355,47.479,47.531,95.592,68.234,144.779l-2.106,0.911l-16.888-36.214l-4.201-9.059l-4.426-8.955l-8.886-17.891 l-8.851-17.905c-2.939-5.973-6.1-11.838-9.139-17.762c-6.157-11.808-12.221-23.663-18.454-35.43 c-25.239-46.911-51.099-93.488-77.914-139.526c-13.583-22.917-26.969-45.948-40.712-68.772l-10.26-17.146l-10.403-17.06 c-6.929-11.378-13.858-22.755-20.901-34.063c-13.894-22.735-27.951-45.372-42.193-67.894 c-14.123-22.596-28.462-45.065-42.864-67.48L589.797,2252.859z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M575.021,2406.865c-0.592,0.072-1.211-0.112-1.675-0.555 c-55.681-53.065-65.233-103.193-63.442-135.9c1.946-35.532,16.924-58.131,17.56-59.076c0.637-0.947,1.918-1.195,2.865-0.559 c0.946,0.637,1.197,1.919,0.561,2.865c-0.15,0.223-15.044,22.758-16.873,57.216c-1.688,31.787,7.729,80.572,62.178,132.463 c0.826,0.787,0.858,2.095,0.071,2.92C575.922,2406.6,575.479,2406.809,575.021,2406.865z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092433458590785642770000015868613723154228671_",
    gradientUnits: "userSpaceOnUse",
    x1: 2350.1899,
    y1: 954.6001,
    x2: 2377.853,
    y2: 954.6001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092433458590785642770000015868613723154228671_)"
    },
    d: "M2358.494,973.788 c-1.266,0-2.548-0.292-3.755-0.902c-4.089-2.077-5.725-7.079-3.648-11.171l11.041-21.755c2.08-4.089,7.075-5.722,11.171-3.648 c4.089,2.077,5.725,7.078,3.648,11.171l-11.041,21.755C2364.443,972.123,2361.526,973.788,2358.494,973.788z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2887.118,2308.139H1874.062c-6.655,0-12.05-5.395-12.05-12.05V982.234 c0-6.655,5.395-12.05,12.05-12.05h1013.057c6.655,0,12.05,5.395,12.05,12.05V2296.09 C2899.168,2302.744,2893.773,2308.139,2887.118,2308.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2830.465,2285.616h-892.547c-22.117,0-40.047-17.929-40.047-40.047V1033.32 c0-22.117,17.93-40.047,40.047-40.047h892.547c22.117,0,40.047,17.93,40.047,40.047v1212.25 C2870.512,2267.687,2852.582,2285.616,2830.465,2285.616z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.94,
      fill: "#FFFFFF"
    },
    cx: 2377.138,
    cy: 1356.896,
    r: 244.333
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033347184535633369350000014321448927692343708_",
    gradientUnits: "userSpaceOnUse",
    x1: 2425.3352,
    y1: 1199.9683,
    x2: 1847.952,
    y2: 2005.7681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033347184535633369350000014321448927692343708_)"
    },
    d: "M2451.944,1264.571 c0,41.372-33.538,86.035-74.91,86.035c-41.372,0-74.91-44.663-74.91-86.035c0-41.371,33.538-70.723,74.91-70.723 C2418.406,1193.848,2451.944,1223.199,2451.944,1264.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005952789456667156940000008251676548566228633_",
    gradientUnits: "userSpaceOnUse",
    x1: 2509.03,
    y1: 1259.9385,
    x2: 1931.6472,
    y2: 2065.7375
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005952789456667156940000008251676548566228633_)"
    },
    d: "M2284.071,1509.891h182.868 c19.25,0,36.293-12.441,42.159-30.776l9.84-30.756c7.205-22.519-4.509-46.9-26.715-55.019 c-74.421-27.21-151.374-23.719-230.204,2.511c-22.084,7.348-34.339,30.97-28.245,53.433l7.577,27.932 C2246.583,1496.502,2264.087,1509.891,2284.071,1509.891z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94,
      fill: "#FFFFFF"
    },
    d: "M2725.354,2142.122h-697.435c-3.682,0-6.667-2.985-6.667-6.667v-102.759 c0-3.682,2.985-6.667,6.667-6.667h697.435c3.682,0,6.667,2.985,6.667,6.667v102.759 C2732.021,2139.137,2729.036,2142.122,2725.354,2142.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003088021692737144550000006235167336523682951_",
    gradientUnits: "userSpaceOnUse",
    x1: 2060.2732,
    y1: 2175.0046,
    x2: 2306.6736,
    y2: 1585.0662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000003088021692737144550000006235167336523682951_)"
    },
    cx: 2098.251,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131328045298550137350000014286135254859126198_",
    gradientUnits: "userSpaceOnUse",
    x1: 2152.6731,
    y1: 2175.0046,
    x2: 2399.0735,
    y2: 1585.0662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000131328045298550137350000014286135254859126198_)"
    },
    cx: 2190.652,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134232565291857910850000007484413911860878471_",
    gradientUnits: "userSpaceOnUse",
    x1: 2242.8381,
    y1: 2175.0046,
    x2: 2489.2385,
    y2: 1585.0663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000134232565291857910850000007484413911860878471_)"
    },
    cx: 2280.816,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050626837210022479500000015383079871504796051_",
    gradientUnits: "userSpaceOnUse",
    x1: 2335.238,
    y1: 2175.0046,
    x2: 2581.6384,
    y2: 1585.0662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000050626837210022479500000015383079871504796051_)"
    },
    cx: 2373.217,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160909226251892245070000008098964654123276960_",
    gradientUnits: "userSpaceOnUse",
    x1: 2430.2729,
    y1: 2175.0046,
    x2: 2676.6733,
    y2: 1585.0663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000160909226251892245070000008098964654123276960_)"
    },
    cx: 2468.251,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106833732403584663780000012836035365775397805_",
    gradientUnits: "userSpaceOnUse",
    x1: 2522.6729,
    y1: 2175.0046,
    x2: 2769.0732,
    y2: 1585.0662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000106833732403584663780000012836035365775397805_)"
    },
    cx: 2560.651,
    cy: 2084.076,
    r: 36.723
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127735918825357028550000007012301957865184921_",
    gradientUnits: "userSpaceOnUse",
    x1: 2615.978,
    y1: 2175.0046,
    x2: 2862.3784,
    y2: 1585.0662
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000127735918825357028550000007012301957865184921_)"
    },
    cx: 2653.957,
    cy: 2084.076,
    r: 36.723
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2438.791,1720.853l-10.278,4.227c-5.104,2.099-10.943-0.336-13.042-5.44l-14.449-35.131 c-5.172-12.575-19.559-18.577-32.135-13.405l-63.688,26.194c-12.575,5.172-18.577,19.559-13.405,32.134l14.449,35.131 c2.099,5.104-0.336,10.943-5.44,13.042l-10.278,4.227c-5.104,2.099-10.943-0.336-13.042-5.44l-14.449-35.131 c-11.705-28.459,1.877-61.019,30.337-72.723l63.687-26.194c28.459-11.705,61.019,1.877,72.724,30.336l14.449,35.131 C2446.331,1712.915,2443.895,1718.754,2438.791,1720.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2451.627,1769.739h-187.866c-11.512,0-20.845,9.332-20.845,20.844v144.18 c0,11.512,9.333,20.845,20.845,20.845h187.866c11.512,0,20.845-9.333,20.845-20.845v-144.18 C2472.472,1779.071,2463.14,1769.739,2451.627,1769.739z M2384.574,1909.089c1.167,4.857-2.514,9.527-7.509,9.527h-38.74 c-4.995,0-8.676-4.67-7.509-9.528l9.04-37.629c-10.671-6.379-17.646-18.302-16.934-31.795 c0.923-17.475,15.083-31.78,32.549-32.865c20.24-1.257,37.047,14.785,37.047,34.754c0,12.711-6.813,23.827-16.984,29.907 L2384.574,1909.089z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162332513086521168200000008018008644984730802_",
    gradientUnits: "userSpaceOnUse",
    x1: 1391.5288,
    y1: 1231.4946,
    x2: 2412.8083,
    y2: 1231.4946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162332513086521168200000008018008644984730802_)"
    },
    d: "M1393.083,1891.685 c-25.838-1007.961,276.559-1249.672,459.114-1304.038c101.621-30.261,212.304-18.344,320.095,34.481 c96.785,47.427,184.45,126.69,240.517,217.471l-14.137,8.731c-102.695-166.276-327.459-308.57-541.732-244.756 c-135.378,40.316-247.193,159.1-323.353,343.501c-92.524,224.027-134.21,541.697-123.892,944.182L1393.083,1891.685z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067216315706901926100000015190023847538988732_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.0919,
    y1: 1370.3988,
    x2: 1512.214,
    y2: 1370.3988
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067216315706901926100000015190023847538988732_)"
    },
    d: "M1399.733,1741.186 c-0.218,0-0.438-0.006-0.659-0.019c-6.413-0.357-11.324-5.845-10.963-12.262c2.531-45.428,4.667-85.99,6.598-122.665 c14.592-277.075,17.627-334.735,94.705-598.26c1.808-6.167,8.283-9.698,14.43-7.9c6.167,1.805,9.704,8.263,7.9,14.43 c-76.316,260.922-78.987,311.617-93.803,592.953c-1.931,36.694-4.067,77.283-6.605,122.74 C1410.992,1736.396,1405.86,1741.186,1399.733,1741.186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140722396291073157610000005082325435242663338_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.8167,
    y1: 625.8018,
    x2: 951.7878,
    y2: 625.8018,
    gradientTransform: "matrix(0.9379 0.3469 -0.3469 0.9379 1766.8633 -33.225)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140722396291073157610000005082325435242663338_)"
    },
    d: "M2394.925,825.737l13.169-1.748 c12.182-1.617,23.153,7.498,23.796,19.77l2.922,55.779c0.791,15.11-14.139,26.097-28.33,20.848l-5.062-1.872 c-6.78-2.508-11.799-8.318-13.294-15.391l-11.029-52.158C2374.56,838.968,2382.771,827.351,2394.925,825.737z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047025095300344501400000008047823975788385953_",
    gradientUnits: "userSpaceOnUse",
    x1: 2400.4126,
    y1: 960.1497,
    x2: 2467.3403,
    y2: 960.1497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047025095300344501400000008047823975788385953_)"
    },
    d: "M2408.719,1024.944 c-4.521,0-8.224-3.625-8.305-8.163c-0.078-4.589,3.576-8.373,8.163-8.455l4.476-0.078c12.343-0.214,23.936-6.429,31.008-16.624 c6.809-9.815,8.477-21.768,4.576-32.79c-1.418-4.005-3.427-7.799-5.969-11.272l-28.545-38.995 c-2.71-3.703-1.905-8.902,1.798-11.612c3.7-2.703,8.899-1.905,11.613,1.798l28.548,38.998c3.495,4.781,6.26,10.009,8.218,15.536 c5.709,16.124,3.307,33.549-6.585,47.81c-10.11,14.573-26.698,23.459-44.37,23.767l-4.476,0.078 C2408.816,1024.944,2408.768,1024.944,2408.719,1024.944z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057108593728391735070000015770225594123614095_",
    gradientUnits: "userSpaceOnUse",
    x1: 1359.9836,
    y1: 1807.4307,
    x2: 1431.4862,
    y2: 1807.4307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057108593728391735070000015770225594123614095_)"
    },
    d: "M1377.131,1712.11h37.207 c9.898,0,17.74,8.356,17.113,18.234l-9.927,156.346c-0.573,9.03-8.065,16.061-17.113,16.061h-27.28 c-9.47,0-17.148-7.677-17.148-17.148v-156.346C1359.984,1719.787,1367.661,1712.11,1377.131,1712.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094604445927423169790000012335184562477482941_",
    gradientUnits: "userSpaceOnUse",
    x1: 1422.6919,
    y1: 1491.329,
    x2: 1348.5654,
    y2: 1542.9928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094604445927423169790000012335184562477482941_)"
    },
    d: "M1222.651,1781.937 c26.731-82.125,43.379-158.378,32.909-218.809c-20.84-21.381-66.379-24.935-111.711-28.64L1222.651,1781.937z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174585679669443978230000015247574106469697184_",
    gradientUnits: "userSpaceOnUse",
    x1: -1986.7712,
    y1: 3512.2075,
    x2: -1834.333,
    y2: 3582.4766,
    gradientTransform: "matrix(-0.6712 0.7412 0.7412 0.6712 -2486.3477 915.4204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000174585679669443978230000015247574106469697184_)"
    },
    points: "1453.062,1782.213  1468.615,1817.379 1435.715,1837.556 1421.595,1816.961  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110441434665436787650000011171096768952147129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1456.5996,
    y1: 1855.4681,
    x2: 1842.1189,
    y2: 1598.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110441434665436787650000011171096768952147129_)"
    },
    d: "M1210.831,1875.31 c0,0,24.696,67.105,97.764,85.619c73.068,18.514,113.197-79.78,112.999-132.488l47.021-11.062 c0,0,57.281,336.304-278.961,210.914L1210.831,1875.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108297297333980454790000004177960978696516493_",
    gradientUnits: "userSpaceOnUse",
    x1: 8075.8579,
    y1: 2947.6079,
    x2: 8250.4482,
    y2: 2947.6079,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108297297333980454790000004177960978696516493_)"
    },
    d: "M1084.037,2982.809 c40.655,1.871,80.007,0.696,106.282-0.655c-23.923-17.028-79.036-54.075-125.155-68.824l-31.658-1.894 c0,0-10.728,16.315-14.555,53.651C1024.197,2971.633,1039.533,2980.761,1084.037,2982.809z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101087400240624129370000003899186557201937807_",
    gradientUnits: "userSpaceOnUse",
    x1: 8075.8579,
    y1: 2978.9993,
    x2: 8250.4482,
    y2: 2978.9993,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101087400240624129370000003899186557201937807_)"
    },
    d: "M1190.646,2982.385 c-0.105-0.074-0.222-0.156-0.327-0.231c-26.275,1.351-65.627,2.526-106.282,0.655c-44.504-2.048-59.84-11.176-65.087-17.722 c-0.177,1.719-0.357,3.428-0.502,5.238c-0.657,8.193,5.424,15.386,13.62,16.007c33.296,2.517,115.85,8.218,155.662,6.13 C1192.98,2992.186,1194.928,2985.438,1190.646,2982.385z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087384232564355567020000004505041784016055464_",
    gradientUnits: "userSpaceOnUse",
    x1: 7766.0791,
    y1: 2942.0679,
    x2: 7847.8286,
    y2: 2942.0679,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087384232564355567020000004505041784016055464_)"
    },
    d: "M790.177,2971.928 c-2.977-19.085-7.752-46.677-11.44-53.732c-5.788-11.066-25.597,0-25.597,0s-3.782-24.965-10.183-14.155 c-4.08,6.89-25.488,57.942-33.133,71.253c-0.881,1.53-1.246,3.16-1.2,4.738l79.323,2.777 C789.886,2979.697,790.797,2975.902,790.177,2971.928z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089543369663870288900000004798566690238622375_",
    gradientUnits: "userSpaceOnUse",
    x1: 7766.0825,
    y1: 2985.2029,
    x2: 7845.4058,
    y2: 2985.2029,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089543369663870288900000004798566690238622375_)"
    },
    d: "M708.624,2980.032 c0.133,4.531,3.724,8.641,8.791,8.781l56.511,1.554c5.971,0.166,11.142-2.937,14.021-7.558L708.624,2980.032z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054260046867729963120000012022298931545614740_",
    gradientUnits: "userSpaceOnUse",
    x1: 7719.7397,
    y1: 2855.5374,
    x2: 7772.7808,
    y2: 2855.5374,
    gradientTransform: "matrix(0.9878 0.1556 -0.1556 0.9878 -6433.7471 -1149.0093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054260046867729963120000012022298931545614740_)"
    },
    d: "M805.63,2844.659 c-1.032,2.155-18.886,49.646-26.711,70.489c-2.163,5.761-8.185,9.097-14.208,7.837c-3.29-0.688-7.1-1.594-11.064-2.754 c-7.032-2.06-11.553-8.914-10.69-16.189c2.253-18.983,7.605-55.269,16.745-68.218 C772.31,2817.963,805.63,2844.659,805.63,2844.659z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036211387921914898410000015545319434494308260_",
    gradientUnits: "userSpaceOnUse",
    x1: 8084.7383,
    y1: 2888.2139,
    x2: 8128.9478,
    y2: 2888.2139,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036211387921914898410000015545319434494308260_)"
    },
    d: "M1027.28,2868.988 c4.396-0.14-1.754,22.698,4.897,45.146c1.5,5.063,5.286,9.037,10.567,9.104c3.421,0.043,7.476-0.022,11.594-0.352 c6.192-0.497,11.167-5.301,11.742-11.486l5.41-58.222L1027.28,2868.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156548311328624650780000004162584975974921355_",
    gradientUnits: "userSpaceOnUse",
    x1: 1087.9589,
    y1: 2189.9934,
    x2: 888.5629,
    y2: 2947.6958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156548311328624650780000004162584975974921355_)"
    },
    d: "M1150.245,2250.085 c-1.963,9.552-71.22,413.518-75.422,622.549c-0.07,3.505-2.65,6.445-6.121,6.928c-8.793,1.226-25.915,2.802-42.518-0.277 c-2.273-0.421-3.987-2.294-4.13-4.601c-2.421-38.954-21.887-368.307,1.954-523.349c0,0-196.922,414.45-226.772,528.729 c-0.726,2.78-3.279,4.65-6.148,4.499c-8.435-0.446-25.973-1.963-39.899-7.089c-4.992-1.837-7.834-7.083-6.575-12.251 c16.677-68.391,133.554-539.59,212.911-643.408L1150.245,2250.085z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106863465128865742570000005755030435887471031_",
    gradientUnits: "userSpaceOnUse",
    x1: 8306.1924,
    y1: 2064.3604,
    x2: 8125.2495,
    y2: 2298.2932,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106863465128865742570000005755030435887471031_)"
    },
    d: "M1024.008,2353.92 c-0.652,0-1.304-0.245-1.808-0.738c-1.021-0.997-1.038-2.635-0.04-3.655l26.369-26.964c0.999-1.023,2.636-1.038,3.656-0.041 c1.02,0.998,1.038,2.636,0.04,3.656l-26.369,26.965C1025.349,2353.661,1024.679,2353.92,1024.008,2353.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067198288848198847350000001785250024779625894_",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.8025,
    y1: 1767.3192,
    x2: 1047.2371,
    y2: 2330.0864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067198288848198847350000001785250024779625894_)"
    },
    d: "M1261.295,1770.202 c-49.249-12.915-117.446-45.344-212.823-29.935c-20.399,3.296-38.005,15.747-41.794,36.06l-90.373,484.372 c-1.392,7.465,4.319,14.366,11.913,14.393l208.149,0.751c7.23,0.026,13.686-4.523,16.094-11.341l120.635-341.606 C1273.095,1922.895,1304.246,1781.465,1261.295,1770.202z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047768928722375548180000002878127259362606493_",
    gradientUnits: "userSpaceOnUse",
    x1: 8217.0713,
    y1: 1805.9424,
    x2: 8237.75,
    y2: 1678.4211,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047768928722375548180000002878127259362606493_)"
    },
    d: "M1139.339,1631.554 c0,0-8.722,52.039-13.9,89.996c-2.395,17.559,9.265,33.959,26.635,37.473c22.865,4.625,52.196,8.739,63.347,2.414 l-2.426-110.804L1139.339,1631.554z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121995951427720419560000018368177345913921153_",
    gradientUnits: "userSpaceOnUse",
    x1: 8285.2686,
    y1: 1596.9551,
    x2: 8144.3838,
    y2: 1704.7532,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121995951427720419560000018368177345913921153_)"
    },
    d: "M1222.643,1547.124 c0,0,24.644,56.612,26.3,86.327c1.655,29.714,8.058,48.995-26.3,54.978c-34.357,5.984-63.3-11.132-78.98-40.73 c0,0-24.567-45.608-19.056-64.286C1130.118,1564.734,1222.643,1547.124,1222.643,1547.124z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150793335786723819350000014334798106228844431_",
    gradientUnits: "userSpaceOnUse",
    x1: 8267.793,
    y1: 1574.1163,
    x2: 8126.9087,
    y2: 1681.9142,
    gradientTransform: "matrix(1 0 0 1 -7057.4585 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150793335786723819350000014334798106228844431_)"
    },
    d: "M1156.471,1631.849 c0,0-9.402-36.163-25.616-26.023c-16.213,10.139,8.414,40.519,21.449,41.872L1156.471,1631.849z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183237574041253448100000016508858759603070110_",
    gradientUnits: "userSpaceOnUse",
    x1: 1048.885,
    y1: 1769.8834,
    x2: 1055.532,
    y2: 2082.2861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183237574041253448100000016508858759603070110_)"
    },
    d: "M1018.203,1752.787l94.928,126.643 c0,0-55.272,67.401-25.98,110.12c8.338,12.163,26.755,12.985,48.822,7.966c-7.45,19.623-12.585,51.385,7.876,88.197 c-56.555,22.426-113.757,19.53-149.571-44.711C914.195,1897.351,1018.203,1752.787,1018.203,1752.787z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100381308219355296910000008198942690266622397_",
    gradientUnits: "userSpaceOnUse",
    x1: 1983.4166,
    y1: 381.181,
    x2: 1053.5145,
    y2: 2048.9387
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100381308219355296910000008198942690266622397_)"
    },
    d: "M1137.195,1986.209 c1.446-0.588,2.295-2.149,1.94-3.72c-0.399-1.745-2.136-2.843-3.88-2.442c-23.465,5.334-38.749,3.099-45.431-6.638 c-27.6-40.252,25.278-105.574,25.814-106.229c1.136-1.384,0.934-3.428-0.451-4.567c-1.386-1.132-3.427-0.931-4.563,0.453 c-2.319,2.829-56.468,69.788-26.146,114.005c8.334,12.155,25.9,15.28,52.211,9.295 C1136.865,1986.329,1137.034,1986.274,1137.195,1986.209z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158746394907671569730000006781809735271719082_",
    gradientUnits: "userSpaceOnUse",
    x1: -817.7348,
    y1: 2422.8516,
    x2: -526.5555,
    y2: 2557.0752,
    gradientTransform: "matrix(-0.9264 0.3765 0.3765 0.9264 -322.6131 -60.6063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158746394907671569730000006781809735271719082_)"
    },
    d: "M1169.252,1993.42 c55.458-12.61,134.029-62.219,134.029-62.219l45.141,9.688c-19.838,34.099-94.978,110.471-171.293,140.728 C1156.667,2044.804,1161.802,2013.042,1169.252,1993.42z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037655468441114415050000008996172724742242442_",
    gradientUnits: "userSpaceOnUse",
    x1: -822.8553,
    y1: 2433.9634,
    x2: -531.6788,
    y2: 2568.1858,
    gradientTransform: "matrix(-0.9264 0.3765 0.3765 0.9264 -322.6131 -60.6063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037655468441114415050000008996172724742242442_)"
    },
    d: "M1305.301,1941.623l-2.02-10.422 c0,0-2.83-41.759,21.704-64.762c24.534-23.004,47.773-19.012,59.026-1.386c11.254,17.626-3.3,39.315-21.647,47.356 C1344.016,1920.451,1363.626,1973.011,1305.301,1941.623z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116202633397769191760000004337342481291203237_",
    gradientUnits: "userSpaceOnUse",
    x1: -2000.91,
    y1: 3480.0405,
    x2: -1760.1595,
    y2: 3591.0186,
    gradientTransform: "matrix(-0.6712 0.7412 0.7412 0.6712 -2486.3477 915.4204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116202633397769191760000004337342481291203237_)"
    },
    d: "M1457.11,1756.988 c-6.024-7.224-34.757-30.384-35.084-17.952c-0.327,12.432-26.597,77.653-20.203,82.663c6.394,5.01,25.865,13.272,38.104-2.191 C1452.167,1804.045,1459.725,1760.125,1457.11,1756.988z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163068786480056844270000008117444863760485557_",
    gradientUnits: "userSpaceOnUse",
    x1: 1196.9932,
    y1: 1520.2715,
    x2: 1030.5179,
    y2: 1852.0809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163068786480056844270000008117444863760485557_)"
    },
    d: "M1196.819,1764.784 c-53.156-117.086-43.898-240.614,58.74-201.656c-29.354-159.414-306.952-79.741-167.684,172.306 C1097.442,1753.643,1163.974,1766.216,1196.819,1764.784z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042726566227685067450000003891254571768927373_",
    gradientUnits: "userSpaceOnUse",
    x1: 1086.2136,
    y1: 1793.6482,
    x2: 1214.2366,
    y2: 1793.6482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042726566227685067450000003891254571768927373_)"
    },
    d: "M1212.576,1853.524 c-0.37,0-0.743-0.123-1.052-0.377c-64.041-52.445-107.343-88.908-125.051-116.823c-0.493-0.772-0.263-1.801,0.513-2.291 c0.769-0.493,1.801-0.266,2.291,0.513c17.445,27.493,60.562,63.791,124.349,116.031c0.711,0.581,0.815,1.629,0.234,2.337 C1213.533,1853.316,1213.056,1853.524,1212.576,1853.524z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047021195243594712540000008221997068479146394_",
    gradientUnits: "userSpaceOnUse",
    x1: 1236.0409,
    y1: 1836.1302,
    x2: 1124.8513,
    y2: 2056.2637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047021195243594712540000008221997068479146394_)"
    },
    d: "M1221.226,1935.266l-1.135-42.593 c11.091-3.153,19.077-13.5,18.755-25.556c-0.38-14.273-12.259-25.535-26.532-25.154c-14.273,0.38-25.535,12.259-25.154,26.532 c0.337,12.627,9.674,22.89,21.704,24.828l0.324,12.173l-6.501,0.173c-2.438,0.065-4.362,2.094-4.297,4.532l0.004,0.161 c0.065,2.438,2.094,4.361,4.532,4.296l6.501-0.173l0.3,11.236l-10.032,0.267c-2.438,0.065-4.361,2.094-4.297,4.532l0.004,0.16 c0.065,2.438,2.094,4.362,4.532,4.297l10.032-0.267l0.023,0.856c0.082,3.073,2.64,5.498,5.713,5.416l0.107-0.003 C1218.883,1940.897,1221.308,1938.34,1221.226,1935.266z M1197.058,1868.232c-0.235-8.806,6.714-16.135,15.52-16.37 c8.806-0.235,16.135,6.714,16.37,15.52c0.235,8.806-6.714,16.135-15.519,16.37 C1204.622,1883.986,1197.293,1877.038,1197.058,1868.232z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183215279728711862330000016200963804239117988_",
    gradientUnits: "userSpaceOnUse",
    x1: 1210.913,
    y1: 1806.8026,
    x2: 1236.1433,
    y2: 1806.8026
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183215279728711862330000016200963804239117988_)"
    },
    d: "M1212.576,1853.524 c-0.198,0-0.396-0.036-0.591-0.107c-0.857-0.328-1.288-1.288-0.964-2.145c13.018-34.214,26.396-72.126,20.294-88.964 c-0.315-0.86,0.133-1.814,0.996-2.126c0.857-0.315,1.814,0.13,2.126,0.996c5.839,16.104-3.895,48.135-20.307,91.274 C1213.877,1853.115,1213.244,1853.524,1212.576,1853.524z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047776636582834782940000004982270684858202538_",
    gradientUnits: "userSpaceOnUse",
    x1: 3372.4907,
    y1: 2684.4128,
    x2: 2722.4941,
    y2: 1612.6401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047776636582834782940000004982270684858202538_)"
    },
    d: "M3061.466,1886.193 c0,0,2.321,32.69,29.042,46.413c45.51,23.372,142.512,64.765,137.17,127.591c-2.095,24.642-25.156,48.052-25.852,71.112 c-0.516,17.076,5.396,33.145,11.057,48.981c15.328,42.883,10.458,75.799-32.103,98.262 c-33.265,17.557-51.668,43.983-57.281,81.097c-8.699,57.531-81.391,58.168-122.224,43.689 c-49.561-17.573-92.549-60.241-108.557-110.697c-7.922-24.969-9.087-58.509,0.453-83.426 c7.809-20.396,16.274-43.056,16.643-65.222c0.414-24.895-13.655-42.036-28.574-60.4c-12.195-15.011-12.353-51.482-8.5-69.271 c4.482-20.688,15.673-40.177,25.86-58.517c19.401-34.928,48.289-72.573,89.437-82.289 C3011.196,1868.048,3040.801,1874.895,3061.466,1886.193z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047031546472248255210000002332812399535017616_",
    gradientUnits: "userSpaceOnUse",
    x1: 2805.9414,
    y1: 1818.1537,
    x2: 2949.9568,
    y2: 2580.3262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047031546472248255210000002332812399535017616_)"
    },
    d: "M2824.661,2068.625 c0,0-231.536-212.731,13.076-201.765c0,0,24.38-83.833,28.881-98.189c5.69,1.857,20.745,18.025,15.038,42.418 c-5.443,23.259,1.424,39.678,1.424,39.678s14.133-21.409,26.397-15.434l-22.116,37.51c0,0-20.11,24.21-35.312,19.249 c-7.146-0.759-165.347-5.659-4.569,95.294c0,0,54.384,15.054,53.499,20.571 C2898.28,2024.761,2846.013,2051.166,2824.661,2068.625z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175294500027206013780000014023671945816814001_",
    gradientUnits: "userSpaceOnUse",
    x1: -4888.8267,
    y1: 3175.2795,
    x2: -4809.1274,
    y2: 3175.2795,
    gradientTransform: "matrix(1 0 0 1 7915.1553 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175294500027206013780000014023671945816814001_)"
    },
    d: "M3026.424,3156.165l4.533,37.268 c0.86,7.069,6.426,12.66,13.502,13.468c11.947,1.365,31.119,2.763,49.877,0.781c8.234-0.87,13.578-9.207,11.071-17.098 c-4.573-14.386-12.938-35.982-25-48.691h-41.341C3031.422,3141.892,3025.5,3148.577,3026.424,3156.165z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120540826039783480200000001183876606125781411_",
    gradientUnits: "userSpaceOnUse",
    x1: -5187.27,
    y1: 3042.9836,
    x2: -5179.9487,
    y2: 3321.2026,
    gradientTransform: "matrix(1 0 0 1 7915.1553 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120540826039783480200000001183876606125781411_)"
    },
    d: "M2718.46,2734.685l-22.81,25.966 c0,0,23.366,236.687,27.523,331.362c0.652,14.843-3.189,29.511-10.978,42.162l-40.632,65.982l103.263-60.935l2.056-12.601 l-16.905-23.243c0,0,19.252-191.438,22.142-265.148c2.891-73.711-15.558-104.106-15.558-104.106L2718.46,2734.685z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130635348944578434810000014132605328264435851_",
    gradientUnits: "userSpaceOnUse",
    x1: -5259.1069,
    y1: 3160.7285,
    x2: -5130.146,
    y2: 3160.7285,
    gradientTransform: "matrix(1 0 0 1 7915.1553 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130635348944578434810000014132605328264435851_)"
    },
    d: "M2664.763,3209.715h32.953 c6.168,0,11.985-2.832,15.748-7.72c10.273-13.349,31.557-39.392,41.735-40.071c13.7-0.916,11.948,47.792,11.948,47.792h7.679 l9.728-60.524c2.447-15.229-5.126-30.314-18.8-37.449c0,0-3.132,23.161-20.114,33.406 c-16.982,10.245-69.105,46.934-69.105,46.934s-6.384-0.91-13.394,0.357C2652.744,3194.318,2654.197,3209.715,2664.763,3209.715z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016784713735800845350000011871348172911385735_",
    gradientUnits: "userSpaceOnUse",
    x1: -4945.1606,
    y1: 3036.6123,
    x2: -4937.8394,
    y2: 3314.8311,
    gradientTransform: "matrix(1 0 0 1 7915.1553 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016784713735800845350000011871348172911385735_)"
    },
    d: "M2844.064,2739.1 c0,0,136.891,259.668,158.651,318.954c21.76,59.286,29.383,108.745,29.675,113.428c0.457,7.318,9.559,14.337,34.649,14.337 c12.948,0,19.29-5.19,22.395-10.214c2.65-4.286,2.786-9.65,0.554-14.168c-7.918-16.025-33.048-67.238-42.354-90.465 c-11.112-27.733-35.014-153.414-48.122-197.112c-13.108-43.697-27.926-91.098-85.01-134.76 C2914.502,2739.1,2875.315,2700.719,2844.064,2739.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011732913313159058540000004672825694713488790_",
    gradientUnits: "userSpaceOnUse",
    x1: 3458.6741,
    y1: 1470.4977,
    x2: 2925.2893,
    y2: 2173.3694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011732913313159058540000004672825694713488790_)"
    },
    d: "M2998.54,2313.62 c-35.312-149.629,54.143-234.257,54.143-234.257c-56.444-54.18-159.285-78.834-159.285-78.834s-98.133,71.744-86.491,127.899 c6.823,32.913,68.978,197.141,68.978,197.141S2933.358,2352.768,2998.54,2313.62z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057862774414429506660000009759439595685223313_",
    gradientUnits: "userSpaceOnUse",
    x1: 2856.8472,
    y1: 2067.9199,
    x2: 2883.2524,
    y2: 2747.845
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057862774414429506660000009759439595685223313_)"
    },
    d: "M2867.148,2389.752 c14.37-43.293,8.737-64.184,8.737-64.184c53.43,22.765,122.655-11.949,122.655-11.949s93.98,43.101,45.845,155.873 c-39.083,91.563-123.052,275.03-123.052,275.03c-87.944,17.819-225.683,16.128-225.683,16.128 C2751.281,2560.517,2852.777,2433.045,2867.148,2389.752z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138563312722670424460000005067570807957189514_",
    gradientUnits: "userSpaceOnUse",
    x1: -116.6972,
    y1: 2075.4805,
    x2: -133.0841,
    y2: 1944.3849,
    gradientTransform: "matrix(-1 0 0 1 2829.3389 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138563312722670424460000005067570807957189514_)"
    },
    d: "M3000.565,1958.998l-14.303,71.605 c2.748,11.359-7.607,9.5-19.091,7.335c-18.806-3.546-43.046-10.849-51.148-25.482c-0.825-1.49-1.237-3.173-1.469-4.86 l30.678-32.071c-0.978-7.094,2.857-13.98,9.403-16.882l23.801-10.554C2987.601,1944.026,2998.207,1949.255,3000.565,1958.998z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083780126197654707290000012124590851158956462_",
    gradientUnits: "userSpaceOnUse",
    x1: -5191.2378,
    y1: 2351.1895,
    x2: -5001.8384,
    y2: 2014.1223,
    gradientTransform: "matrix(0.9917 0.1286 -0.1286 0.9917 8343.2422 355.9484)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083780126197654707290000012124590851158956462_)"
    },
    d: "M2977.379,1843.369 c0,0-35.565,9.867-64.809,55.619c-29.245,45.752-15.039,70.469,6.066,76.347c21.105,5.876,57.671,0.891,95.771-26.174 C3052.507,1922.096,3023.401,1832.175,2977.379,1843.369z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157294034815279030120000015473008043074318255_",
    gradientUnits: "userSpaceOnUse",
    x1: 3467.179,
    y1: 2628.6968,
    x2: 2817.1841,
    y2: 1556.927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157294034815279030120000015473008043074318255_)"
    },
    d: "M2990.569,1928.867 c0,0,34.682-67.988-28.411-77.025l-16.22,8.466c0,0-18.065-42.53,22.442-56.462c40.508-13.932,83.033,7.428,92.582,60.805 c9.549,53.379,7.865,88.064-22.263,109.103c-30.128,21.04-37.626-8.218-37.626-8.218s17.649-21.044,13.266-34.095 c-4.382-13.052-20.081,8.663-20.081,8.663L2990.569,1928.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090296906940232725400000002327934808583855280_",
    gradientUnits: "userSpaceOnUse",
    x1: -267.6009,
    y1: 2099.7913,
    x2: -399.7003,
    y2: 1821.9937,
    gradientTransform: "matrix(-1 0 0 1 2829.3389 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090296906940232725400000002327934808583855280_)"
    },
    d: "M3124.071,1918.343 c0,0,162.147,211.395-71.387,161.019c-46.326,29.029-42.007,64.955-42.007,64.955s396.653,50.204,146.49-219.664 c-4.079-4.401-3.499-10.968-4.021-16.945c-1.1-12.574-11.436-36.405-12.149-49.007c-0.888-15.69-24.139-50.137-38.94-46.684 c-10.097,2.356-6.23,19.772-4.57,30.006l18.983,43.311c1.937,11.94-1.395,9.013-13.457,8.12c0,0-7.431-2.514-8.184-0.606 C3092.458,1898.852,3124.071,1918.343,3124.071,1918.343z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3162.971,2029.624c-0.799,0-1.444-0.649-1.444-1.444c0-5.575-12.221-47.621-65.559-69.925 c-27.895-11.669-39.341-34.672-44.027-51.921c-5.058-18.603-3.583-34.22-3.515-34.875c0.079-0.796,0.778-1.377,1.58-1.298 c0.793,0.079,1.371,0.79,1.292,1.579c-0.014,0.158-1.487,15.821,3.453,33.927c6.587,24.132,20.829,40.929,42.334,49.923 c54.778,22.903,67.33,66.76,67.33,72.589C3164.415,2028.975,3163.769,2029.624,3162.971,2029.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3146.605,2050.811c-0.034,0-0.067,0-0.102-0.005c-0.796-0.051-1.396-0.745-1.343-1.541 c1.854-26.902-30.503-56.796-30.83-57.095c-0.589-0.536-0.632-1.45-0.093-2.042c0.539-0.581,1.453-0.626,2.04-0.091 c1.38,1.259,33.716,31.129,31.766,59.431C3147.99,2050.23,3147.355,2050.811,3146.605,2050.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3146.679,2263.38c-0.68,0-1.287-0.485-1.417-1.174c-0.149-0.784,0.367-1.54,1.151-1.693 c19.993-3.775,33.197-18.208,39.239-42.887c4.554-18.603,3.098-36.28,3.084-36.455c-0.068-0.796,0.519-1.495,1.315-1.563 c0.745-0.107,1.492,0.519,1.563,1.314c0.017,0.181,1.512,18.332-3.157,37.392c-6.246,25.515-20.6,41.087-41.508,45.043 C3146.859,2263.375,3146.769,2263.38,3146.679,2263.38z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/login2.519da0d1708aaa2b55b8e634df37a443.svg";
export { ForwardRef as ReactComponent };